export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('POURCENTAGE_DIVISION') === 0) {
      messages.push({
        message: 'ajoutEditContrat.echeancier.popUpCreation.messages.error.repartitionError',
      });
    }
    if (message.indexOf('DUPLICATION_FORBIDDEN') === 0) {
      messages.push({
        message: 'ajoutEditContrat.echeancier.popUpCreation.messages.error.duplicationInterdite',
      });
    }
    if (message.indexOf('RANGE_0_100') === 0) {
      messages.push({
        message: 'ajoutEditContrat.echeancier.popUpCreation.messages.error.tva',
      });
    }
    if (message.indexOf('ECH_FIRST_ENDDATE_OUTSIDE_RANGE') === 0) {
      messages.push({
        message: 'ajoutEditContrat.echeancier.popUpCreation.messages.error.firstEcheanceOutside',
      });
    }
    if (message.indexOf('ECH_DATE_START_GREATER_THAN_END_DATE') === 0) {
      messages.push({
        message: 'ajoutEditContrat.echeancier.popUpCreation.messages.error.dateDebutGreaterDateFin',
      });
    }
    if (message.indexOf('SHOULD_HAVE_PAYMENT_TYPE_WITH_PURCHASE_ACTION') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'ajoutEditContrat.echeancier.popUpCreation.messages.error.bailleurModePaiement',
        parametres: { bailleur: elements[1] },
      });
    }
    if (message.indexOf('RANGE_1_2147483647') === 0) {
      messages.push({
        message: 'ajoutEditContrat.echeancier.popUpCreation.messages.error.outOfRangePeriode',
      });
    }
    if (message.indexOf('COMMAND_BAD_STATE') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'detailContrat.echeancier.actionErrors.badState',
        parametres: { cmdCode: elements[1] },
      });
    }
    if (message.indexOf('BILLBOARD_LINE_BILL_DONE_STATE_INVALID') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'detailContrat.echeancier.actionErrors.billboardLineBillDoneStateInvalid',
        parametres: { cmdCode: elements[1] },
      });
    }
    if (message.indexOf('BILLBOARD_LINE_REAL_BILL_EXISTS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'detailContrat.echeancier.actionErrors.billboardLineRealBillExists',
        parametres: { cmdCode: elements[1] },
      });
    }
    if (message.indexOf('BILLBOARD_LINE_BILL_DONE_STATE_INVALID_TOO') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'detailContrat.echeancier.actionErrors.billboardLineBillDoneStateInvalidToo',
        parametres: { cmdCode: elements[1] },
      });
    }
    if (message.indexOf('UNSOLDE_BAD_STATE') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'detailContrat.echeancier.actionErrors.unsoldeBadState',
        parametres: { cmdCode: elements[1] },
      });
    }
    if (message.indexOf('ALL_ECHEANCE_MUST_BE_A_RAPPROCHER') === 0) {
      messages.push({ message: 'detailContrat.echeancier.actionErrors.allARapprocher' });
    }
    if (message.indexOf('ALL_ECHEANCE_MUST_HAVE_SAME_TIERS') === 0) {
      messages.push({ message: 'detailContrat.echeancier.actionErrors.allSameTiers' });
    }
    if (message.indexOf('ALL_ECHEANCE_MUST_NOT_HAVE_FACTURE') === 0) {
      messages.push({ message: 'detailContrat.echeancier.actionErrors.allNoFacture' });
    }
  });
}
